import { Point, Size } from 'gojs';

export const getPointString = (x: number, y: number) => Point.stringify(new Point(x, y));

export const getSizeString = (width: number, height: number) => Size.stringify(new Size(width, height));
